export default {
  'courses.tooltips.title': 'Entrez le titre du cours que vous créez.',
  'courses.tooltips.subtitle':
    'Entrez le sous-titre du cours que vous créez pour compléter le titre.',
  'courses.tooltips.summary': 'Décrivez brièvement et de manière générale le sujet de votre cours.',
  'courses.tooltips.description':
    'Ajoutez une description à votre cours, par ex. matériaux/vocabulaire utiles.',
  'courses.tooltips.active_from': 'Sélectionnez la date de début de votre cours.',
  'courses.tooltips.active_to': 'Sélectionnez la date de fin de votre cours.',
  'courses.tooltips.level': 'Choisissez votre niveau de cours.',
  'courses.tooltips.target_group': 'Sélectionnez le groupe cible de votre cours.',
  'courses.tooltips.duration': 'Spécifiez la durée de votre cours en minutes.',
};
